<template>
  <BasePanelWithHeader headerText="Agency Users">
    <v-row v-if="userAdminAgencies.length > 1">
      <v-col>
        <LuAgency
          v-model="selectedAgencyID"
          :items="userAdminAgencies"
        ></LuAgency>
      </v-col>
    </v-row>
    <div v-show="selectedAgencyID > 0">
        <!-- :searchText.sync="searchText" -->
      <BaseServerSyncDataTable
        :headers="filteredHeaders"
        :items="mappedUsers"
        :search="false"
        itemKey="Id"
        :loading="loading"
        :searchTotal="searchTotal"
        :searchSortBy.sync="searchSortBy"
        :searchDescending.sync="searchDescending"
        :searchPage.sync="searchPage"
        :searchRowsPerPage.sync="searchRowsPerPage"
      >
        <!-- //templateTodo: uncomment use custom search params-->
        <template v-slot:searchParams>
          <v-row>
            <v-col class="ml-auto" cols="12" sm="auto">
              <v-text-field
                v-model="searchText"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                clearable
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="auto" class="mt-4 mr-4">
              <BaseTooltipButton
                small
                @click="$refs.userForm.addUser()"
                icon="mdi-plus"
                iconColor="white"
                buttonClass="primary"
                >Add User
              </BaseTooltipButton>
            </v-col>
          </v-row>
      </template>
        <template v-slot:item.edit="{ item }">
          <BaseTooltipButton
            small
            @click="$refs.userForm.editUser(item)"
            iconColor="primary"
            icon="mdi-pencil"
            >Edit User
          </BaseTooltipButton>
        </template>
        <template v-slot:item.delete="{ item }">
          <BaseTooltipButton
            small
            @click="$refs.userDelete.deleteConfirm(item)"
            iconColor="primary"
            icon="mdi-delete"
            >Delete User
          </BaseTooltipButton>
        </template>
      </BaseServerSyncDataTable>
    </div>
    <BaseDeleteConfirm
      ref="userDelete"
      :delete="deleteUser"
      @refresh="searchUsers"
    >
      Are you sure you want to delete this user?
    </BaseDeleteConfirm>
    <UserDialogForm 
     :selectedAgencyID="selectedAgencyID"
    ref="userForm" @refresh="searchUsers"> </UserDialogForm>
  </BasePanelWithHeader>
</template>

<script>
import { authComputed } from '@state/helpers'
import { get, sync, commit, call } from 'vuex-pathify'
//templateTodo: uncomment use custom search params
// import UserParams from '@components/search/UserParams'
import LuAgency from '@components/select/single/LuAgency'
import UserDialogForm from '@components/form/add-edit/UserDialog'

export default {
  name: 'UserSearchTable',
  components: {
    //templateTodo: uncomment use custom search params
    // UserParams,
    UserDialogForm,
    LuAgency
  },
  data: () => ({
    selectedAgencyID: 0,
  }),
  created() {
    if (this.userAdminAgencies.length == 1) {
      this.searchAgencyId = [this.userAdminAgencies[0].ID]
      this.selectedAgencyID = this.userAdminAgencies[0].ID
      if (this.searchAgencyId.length > 0) {
        this.searchUsers()
      }
    }
  },
  computed: {
    ...authComputed,
    ...get('user', ['users', 'loading']),
    ...sync('user', [
      'searchTotal',
      'searchPage',
      'searchSortBy',
      'searchDescending',
      'searchRowsPerPage',
      'searchText',
      'searchShowInactive',
      'searchAgencyId',
    ]),
    headers() {
      return [
        {
          text: '',
          align: 'center',
          value: 'edit',
          visible: true,
          sortable: false,
        },
        {
          text: 'ID',
          align: 'center',
          sortable: true,
          value: 'ID',
          visible: false,
        },
        {
          text: 'First Name',
          align: 'center',
          sortable: true,
          value: 'FirstName',
          visible: true,
        },
        {
          text: 'Last Name',
          align: 'center',
          sortable: true,
          value: 'LastName',
          visible: true,
        },
        {
          text: 'Email',
          align: 'center',
          sortable: true,
          value: 'Email',
          visible: true,
        },
        {
          text: 'Roles',
          align: 'center',
          sortable: true,
          value: 'roles',
          visible: true,
        },
        {
          text: 'Is Active',
          align: 'center',
          sortable: true,
          value: 'IsActive',
          visible: this.searchShowInactive,
        },
        {
          text: 'Office Phone',
          align: 'center',
          sortable: true,
          value: 'OfficePhone',
          visible: false,
        },
        {
          text: 'Mobile Phone',
          align: 'center',
          sortable: true,
          value: 'MobilePhone',
          visible: false,
        },
        {
          text: 'Agency',
          align: 'center',
          sortable: true,
          value: 'Agency',
          visible: false,
        },
        {
          text: 'Division',
          align: 'center',
          sortable: true,
          value: 'Division',
          visible: false,
        },
        {
          text: '',
          align: 'center',
          value: 'delete',
          visible: false,
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
    mappedUsers() {
      return this.users.map((item) => {
          return {
            ...item,
            agencyRoles: item.UserAgencies.filter(
              (ua) => ua.AgencyID == this.selectedAgencyID
            )
              .map((i) => i.AgencyRole.Description)
              .join(', '),
          }
      })
    },
  },
  methods: {
    ...call('user', ['deleteUser', 'searchUsers']),
    // searchUsers: call('user/searchUsers'),
  },
  watch: {
    selectedAgencyID(nval, oval) {
      this.searchAgencyId = [nval]
    }
  }
}
</script>

<style></style>
